import React, { Component } from 'react';
import { Oval } from 'react-loader-spinner';
import {
  ExportButton,
  ExportButtonWrapper,
  ExportButtonsWrapper,
  ExportFormatBtnIcon,
  ExportPopUp,
  ExportTitle,
  PopUpCloseBtn,
  PopUpHeader,
  PopUpTitle,
  SeparatorLine,
  SpinnerContainer
} from '../../CapaLlegendaFooterElements';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';
import { config } from '../../../../../../config/Config';
import { construirURLExport } from './ExportLayerUtils';
import { toast } from 'react-toastify';
import ExportCorreuModal from './ExportCorreuModal';

export default class ExportLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalCorreuOpen: false,
      clickedButton: null
    };
  }
  componentDidUpdate(prevProps) {
    if (prevProps.showAlert !== this.props.showAlert && this.props.showAlert === false) {
      this.setState({ clickedButton: null });
      this.props.handleExportClose();
    }
  }
  handleLoading = (status) => {
    this.setState({ downloading: status });
  };

  /**
   *
   * @param bbox coordenadas
   * @desc Función para convertir bbox a WKT
   */
  bboxToWkt = (bbox) => {
    // Extrae las coordenadas del bbox
    const coordinates = bbox.match(/[\d.]+/g);

    // Si no se encuentran 4 coordenadas, retorna null
    if (coordinates.length !== 4) {
      return null;
    }

    const [x1, y1, x2, y2] = coordinates;

    // Construye el polígono WKT
    const wktPolygon = `POLYGON((${x1} ${y1}, ${x2} ${y1}, ${x2} ${y2}, ${x1} ${y2}, ${x1} ${y1}))`;

    return wktPolygon;
  };

  /**
   *
   * @param cqlFilter cqlFilter
   * @desc Funcion para convertir CQL a SQL
   */
  convertCqlToSql = (cqlFilter) => {
    let sqlFilter = cqlFilter.replace(/(\w+)\s+(NOT\s+)?ILIKE\s+'([^']+)'/gi, function (match, p1, p2, p3) {
      return 'UPPER(' + p1 + ') ' + (p2 || '') + "ILIKE UPPER('" + p3 + "')";
    });

    sqlFilter = sqlFilter.replace(/(\w+)\s+<>\s+'([^']+)'/gi, function (match, p1, p2) {
      return 'UPPER(' + p1 + ") <> UPPER('" + p2 + "')";
    });

    return sqlFilter;
  };

  /**
   *
   * @param filtroCapa filtro a aplicar a la capa
   * @param bodyRequest objeto que conteiene la información necesaria para la petición
   * @desc Función para aplicar el filtro correspondiente a la capa seleccionada
   */
  aplicarFilter = (filtroCapa, bodyRequest) => {
    if (filtroCapa === undefined) filtroCapa = '';
    if (filtroCapa.startsWith('INTERSECTS')) {
      let firstAndIndex = filtroCapa.indexOf(' AND ');
      let paramsFilter;
      if (firstAndIndex !== -1) {
        let part1 = filtroCapa.substring(0, firstAndIndex);
        let part2 = filtroCapa.substring(firstAndIndex + ' AND '.length);
        paramsFilter = [part1, part2];
      } else {
        paramsFilter = [filtroCapa];
      }

      if (paramsFilter[1]) {
        // Recogemos el filtro alfanumerico
        let str = paramsFilter[1].replace('(', '');
        str = str.replace(/(.*)(\))(.*)/, '$1$3');

        let strEncoded = encodeURIComponent(this.convertCqlToSql(str));
        bodyRequest.FILTER = strEncoded;
        bodyRequest.WKT = paramsFilter[0].replace(/INTERSECTS\((GEOMETRIA|GEOMETRY|SHAPE|GEOM), |\)($)/g, '');
      } else {
        bodyRequest.WKT = paramsFilter[0].replace(/INTERSECTS\((GEOMETRIA|GEOMETRY|SHAPE|GEOM), |\)($)/g, '');
      }
    } else if (filtroCapa.startsWith('BBOX')) {
      //let paramsFilter = filtroCapa.split(' AND  ');
      let firstAndIndex = filtroCapa.indexOf(' AND ');
      let paramsFilter;
      if (firstAndIndex !== -1) {
        let part1 = filtroCapa.substring(0, firstAndIndex);
        let part2 = filtroCapa.substring(firstAndIndex + ' AND '.length);
        paramsFilter = [part1, part2];
      } else {
        paramsFilter = [filtroCapa];
      }

      // Recogemos el filtro alfanumerico
      if (paramsFilter[1]) {
        let str = paramsFilter[1].replace('(', '');
        str = str.replace(/(.*)(\))(.*)/, '$1$3');
        let strEncoded = encodeURIComponent(this.convertCqlToSql(str));
        bodyRequest.FILTER = strEncoded;
        bodyRequest.WKT = this.bboxToWkt(paramsFilter[0].replace(/BBOX\(GEOMETRIA, |\)($)/g, ''));
      } else {
        bodyRequest.WKT = this.bboxToWkt(paramsFilter[0].replace(/BBOX\(GEOMETRIA, |\)($)/g, ''));
      }
    } else {
      // En el caso de que no haya ningun filtro espacial aplicado, solamente alfanumerico
      let strEncoded = encodeURIComponent(this.convertCqlToSql(filtroCapa));
      bodyRequest.FILTER = strEncoded;
    }
  };

  /**
   *
   * @param url url de exportación
   * @desc Función para aplicar la extensión seleccionada a la descarga
   */
  aplicarExtension = (url) => {
    let extensionDescarga;
    if (url.OUTPUTFORMAT === 'GML3') {
      extensionDescarga = 'GML';
    } else if (url.OUTPUTFORMAT === 'SHAPE-ZIP') {
      extensionDescarga = 'SHP';
    } else {
      extensionDescarga = url.OUTPUTFORMAT;
    }

    return extensionDescarga;
  };

  // Añade estilo y metadatos a la petición
  handleLayerStylesAndMetadata = (layer, url, bodyRequest) => {
    let estilSLD = '';
    let uuidMeta = '';

    if (layer.getCurrentStyle() !== undefined) estilSLD = layer.getCurrentStyle().getName();
    if (layer.hasMetadata()) uuidMeta = layer.getIndexUUID();
    if (estilSLD !== '') url.ESTIL_SLD = estilSLD;
    if (uuidMeta !== undefined) url.UUID_META = uuidMeta;
    bodyRequest.ESTIL_SLD = estilSLD;
    bodyRequest.UUID_META = uuidMeta;
  };

  // Añade nombre de la capa a la petición
  handleLayerName = (layer, bodyRequest) => {
    let nombreCapa = layer.getName();
    bodyRequest.nombreCapa = nombreCapa;
  };

  // Añade filtro de la capa a la petición
  handleLayerFilter = (url, bodyRequest) => {
    let filtroCapa = url.CQL_FILTER;
    this.aplicarFilter(filtroCapa, bodyRequest);
    let rawFilterEncoded = filtroCapa;
    if (rawFilterEncoded !== undefined) {
      bodyRequest.CQL_FILTER = rawFilterEncoded;
    } else {
      bodyRequest.CQL_FILTER = '';
    }
  };

  // Añade extensión a la petición
  handleOutputFormat = (url, bodyRequest) => {
    bodyRequest.OUTPUTFORMAT = this.aplicarExtension(url); // ADD OUTPUTFORMAT
  };

  // Añade email del usuario a la petición si está loggeado
  handleUserEmail = async () => {
    let userEmail = '';
    if (this.props.user) {
      let emailUserURL = config.url_getUserEmail;
      try {
        const response = await fetch(emailUserURL, { method: 'GET', headers: { 'Content-Type': 'application/json' } });
        if (!response.ok) {
          return userEmail;
        }
        userEmail = response.text();
      } catch (error) {
        userEmail = '';
      }
    }
    return userEmail;
  };

  /**
   *
   * @param url url de exportación
   * @param layer capa que se quiere exportar
   * @desc Función para exportar una capa
   */
  ferExportacio = async (url, layer) => {
    let bodyRequest = {};
    let exportURL = config.url_getExport;
    if (this.props.user) exportURL = '/login' + exportURL;

    this.handleLayerStylesAndMetadata(layer, url, bodyRequest);
    this.handleLayerName(layer, bodyRequest);
    this.handleLayerFilter(url, bodyRequest);
    this.handleOutputFormat(url, bodyRequest);

    // Si la capa tiene escala, se aplica el estilo genérico
    if (layer.currentStyleHasScale() && bodyRequest.OUTPUTFORMAT === 'KML') {
      bodyRequest.ESTIL_SLD = 'generic';
    }

    bodyRequest.emailAddress = '';
    bodyRequest.opt_servicemode = 'async';

    let userEmail = await this.handleUserEmail();

    this.props.toggleAlert(
      true,
      <ExportCorreuModal
        fontSizeEnabled={this.props.fontSizeEnabled}
        toggleAlert={this.props.toggleAlert}
        bodyRequest={bodyRequest}
        exportURL={exportURL}
        userEmail={userEmail}
        handleLoading={this.handleLoading}
      />,
      getTranslatedKey('modalExportTitle'),
      true,
      false,
      true
    );
  };

  handleButtonClick = (buttonId) => {
    this.setState({ clickedButton: buttonId });
  };

  getLimitLayerSize = async () => {
    const urlLimitMida = config.url_getLimitLayerSize;

    try {
      const response = await fetch(urlLimitMida);

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.text();
      const result = parseInt(data);

      return result;
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      throw error; // Propagate the error if needed
    }
  };

  /**
   * Comprueba si el tamaño de la capa es inadecuado en función de un filtro dado.
   * @param {string} filter - El filtro a aplicar a la capa.
   * @returns {boolean}
   */
  midaInadequada = async (filter) => {
    try {
      const limit = await this.getLimitLayerSize();
      const layerSize = this.props.layer.getSize();
      if (filter) {
        let totalElements = await this.getTableTotalElements();
        let currentElements = await this.getTableCurrentElements(filter);
        return (currentElements / totalElements) * layerSize > limit;
      } else {
        return layerSize > limit;
      }
    } catch (error) {
      console.error('Error in async/await:', error);
    }
  };

  /**
   * Obtiene el número total de elementos de la tabla.
   * @returns {Promise<string>} El número total de elementos de la tabla.
   */
  getTableTotalElements = async () => {
    let url = this.props.layer.getOnlineResource();
    let layerName = this.props.layer.getExtension().Namespace + ':' + this.props.layer.getName();
    url = `${url}?service=wfs&version=1.1.0&request=GetFeature&typename=${layerName}&resultType=hits`;

    const result = await fetch(url);

    const xmlText = await result.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    const numberMatched = xmlDoc.documentElement.getAttribute('numberOfFeatures');
    return numberMatched;
  };

  getTableCurrentElements = async (filter) => {
    let url = this.props.layer.getOnlineResource();
    let layerName = this.props.layer.getExtension().Namespace + ':' + this.props.layer.getName();
    let encodedFilter = filter.replace(/%/g, '%25');
    url = `${url}?service=wfs&version=1.1.0&request=GetFeature&typename=${layerName}&resultType=hits&cql_filter=${encodedFilter}`;

    const result = await fetch(url);

    const xmlText = await result.text();
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    const numberMatched = xmlDoc.documentElement.getAttribute('numberOfFeatures');
    return numberMatched;
  };

  handleDownloadLayer = async (type, buttonId) => {
    let url = construirURLExport(type, this.props.layer, this.props.taulaFullFilter);

    const isSizeInadequateKML = await this.midaInadequada(url.CQL_FILTER);
    if (isSizeInadequateKML) {
      !url.CQL_FILTER
        ? toast.error(getTranslatedKey('errorLayerExportSize'), {
            autoClose: 8000,
            pauseOnHover: true
          })
        : toast.error(getTranslatedKey('errorLayerExportFilteredSize'), {
            autoClose: 8000,
            pauseOnHover: true
          });
    } else {
      this.ferExportacio(url, this.props.layer, buttonId);
    }
    this.handleButtonClick(buttonId);
  };

  /**
   *
   * @param {*} type formato de exportación
   * @desc Función invocada al clickar al boton de exportar
   */
  onExportClick = async (type) => {
    switch (type) {
      case 'KML':
        this.handleDownloadLayer(type, 1);
        return;
      case 'CSV':
        this.handleDownloadLayer(type, 2);
        return;
      case 'SHAPE-ZIP':
        this.handleDownloadLayer(type, 3);
        return;
      case 'GML3':
        this.handleDownloadLayer(type, 4);
        return;
      case 'TIF':
        this.handleDownloadLayer(type, 5);
        return;
      default:
        return;
    }
  };

  render() {
    return (
      <>
        <SeparatorLine />
        <ExportPopUp>
          <PopUpHeader>
            <PopUpTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('titleExport')}</PopUpTitle>
            <PopUpCloseBtn title={getTranslatedKey('tancar')} onClick={() => this.props.handleExportClose()}>
              <svg
                width={this.props.fontSizeEnabled ? 24 * 1.3 : 24}
                fill="white"
                transform="rotate(180)"
                focusable="false"
                aria-hidden="true"
                viewBox="0 0 24 24"
                data-testid="ExpandMoreIcon">
                <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
              </svg>
            </PopUpCloseBtn>
          </PopUpHeader>
          {!this.state.downloading ? (
            this.props.layer.isRasterLayer() ? (
              <ExportButtonWrapper>
                <ExportButton
                  title={getTranslatedKey('TIFText')}
                  onClick={() => this.onExportClick('TIF')}
                  style={{ color: this.state.clickedButton === 5 ? '#febf00' : 'white' }}>
                  <ExportFormatBtnIcon fontSizeEnabled={this.props.fontSizeEnabled}>
                    <path
                      class="st0"
                      d="M452,244h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331,24c-2.2-2.4-5.4-3.8-8.6-3.8H104.6c-22.1,0-40,17.9-40,40v184  H60c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.2,244,452.1,244,452,244L452,244z M334.3,61l72,72h-72V61z M88.6,60  c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1V244H88.6V60z M423.4,452c0,8.8-7.2,16-16,16H104.6c-8.8,0-16-7.2-16-16  v-24h334.9v24H423.4z M126.3,304v91.7H91.2V304h-25v-28.9h85.1V304H126.3z M212.4,275.1v120.6h-37V275.1H212.4z M322.4,350.5h-39.3  v45.2H247V275.1h87.2v28.7h-51.2v19.6h39.3V350.5z M435,350.5h-39.3v45.2h-36.1V275.1h87.2v28.7h-51.2v19.6H435V350.5z"
                    />
                  </ExportFormatBtnIcon>
                  <ExportTitle title={getTranslatedKey('TIFText')} fontSizeEnabled={this.props.fontSizeEnabled}>
                    {getTranslatedKey('TIFText')}
                  </ExportTitle>
                </ExportButton>
              </ExportButtonWrapper>
            ) : (
              <ExportButtonsWrapper>
                <ExportButtonWrapper>
                  <ExportButton
                    title={getTranslatedKey('GMLText')}
                    onClick={() => this.onExportClick('GML3')}
                    style={{ color: this.state.clickedButton === 4 ? '#febf00' : 'white' }}>
                    <ExportFormatBtnIcon fontSizeEnabled={this.props.fontSizeEnabled}>
                      <path d="M451.9,244.6h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L330.9,24.6c-2.2-2.4-5.4-3.8-8.6-3.8H104.5  c-22.1,0-40,17.9-40,40v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9  c22.1,0,40-17.9,40-40v-24h4.6c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.1,244.6,452,244.6,451.9,244.6  L451.9,244.6z M334.2,61.6l72,72h-72V61.6z M88.5,60.6c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H88.5V60.6z   M423.3,452.6c0,8.8-7.2,16-16,16H104.5c-8.8,0-16-7.2-16-16v-24h334.9v24H423.3z M174.7,329.4v61.1h-18.3  c-1.5-4.5-3.1-8.3-4.9-11.4c-7.6,8.8-18.7,13.2-33.6,13.2c-15.7,0-28.6-4.9-38.7-14.7s-15.2-23.1-15.2-40c0-16.3,4.9-30,14.7-41.2  c9.7-11.2,24.3-16.6,43.7-16.6c14.5,0,26.2,3.3,35.1,10s14.6,16,17.2,28.1l-36.2,3.2c-1.8-11.4-7.4-17.1-16.7-17.1  c-12.2,0-18.4,10.4-18.4,31.3c0,12.6,2,21,5.9,25s8.7,6.1,14.2,6.1c4.5,0,8.4-1.2,11.5-3.7c3.2-2.5,4.7-5.8,4.9-10.1h-20.2v-23.3  H174.7z M334.1,281.3v109.2h-34.8v-78.1l-22.5,78.1H253l-23.4-78.1v78.1h-28V281.3h48.9l17.7,58l16.8-58H334.1z M447.9,363.7v26.8  h-85.4V281.3h37.4v82.3H447.9z" />
                    </ExportFormatBtnIcon>
                    <ExportTitle title={getTranslatedKey('GMLText')} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('GMLText')}
                    </ExportTitle>
                  </ExportButton>
                </ExportButtonWrapper>
                <ExportButtonWrapper>
                  <ExportButton
                    title={getTranslatedKey('CSVText')}
                    onClick={() => this.onExportClick('CSV')}
                    style={{ color: this.state.clickedButton === 2 ? '#febf00' : 'white' }}>
                    <ExportFormatBtnIcon fontSizeEnabled={this.props.fontSizeEnabled}>
                      <path d="M452.4,244.6h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331.4,24.6c-2.2-2.4-5.4-3.8-8.6-3.8H105c-22.1,0-40,17.9-40,40  v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40H65v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.6,244.6,452.5,244.6,452.4,244.6L452.4,244.6z M334.7,61.6l72,72h-72  V61.6z M89,60.6c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H89V60.6z M423.8,452.6c0,8.8-7.2,16-16,16H105  c-8.8,0-16-7.2-16-16v-24h334.9v24H423.8z M148.7,350.7l35.6,1.9c-1.7,14-7.4,24.6-17.3,32.1c-9.8,7.4-21.9,11.1-36.3,11.1  c-17.2,0-31.2-5.1-41.8-15.3C78.3,370.1,73,356,73,338c0-17.8,5.1-32.3,15.1-43.2c10-10.9,24.1-16.5,42.1-16.5  c16.8,0,29.7,4.2,38.7,12.5c9,8.3,14.1,19.4,15.3,33.2l-36.4,1.7c0-7.7-1.6-13.1-4.8-16.5c-3.2-3.3-7.1-5.1-11.5-5.1  c-12.3,0-18.4,11-18.4,33.2c0,12.4,1.6,20.8,4.8,25.2c3.2,4.5,7.7,6.7,13.5,6.7C141.7,369.5,147.5,363.2,148.7,350.7z M194.1,361.2  l36.3-5.8c3.1,9.2,10.9,13.7,23.5,13.7c9.8,0,14.7-2.4,14.7-7.1c0-2.5-1.1-4.3-3.3-5.7c-2.2-1.4-6.3-2.6-12.1-3.6  c-22.3-3.8-36.6-8.8-42.9-15c-6.3-6.2-9.5-13.5-9.5-21.8c0-10.8,4.6-19.7,13.6-26.7c9-7.2,22.2-10.6,39.2-10.6  c25.9,0,42.9,9.3,51.2,28l-32.3,8.8c-3.3-7.7-10.1-11.4-20.4-11.4c-8.5,0-12.7,2.4-12.7,7.1c0,2.1,1,3.7,2.8,5  c2,1.1,5.7,2.2,11.1,3.3c15.2,2.8,26,5.4,32.4,7.7c6.4,2.2,11.8,6.1,16,11.4c4.2,5.3,6.4,11.8,6.4,18.9c0,11.5-5.2,20.8-15.6,28  c-10.4,7.2-24.1,10.8-41.1,10.8C220.4,395.9,201.4,384.3,194.1,361.2z M439,280.2l-39.5,113.9h-39.7l-41.2-113.9h41.1l20.1,62  c1.4,3.7,2.6,7.3,3.6,10.9l23.5-72.9H439z" />
                    </ExportFormatBtnIcon>
                    <ExportTitle title={getTranslatedKey('CSVText')} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('CSVText')}
                    </ExportTitle>
                  </ExportButton>
                </ExportButtonWrapper>
                <ExportButtonWrapper>
                  <ExportButton
                    title={getTranslatedKey('KMLText')}
                    onClick={() => this.onExportClick('KML')}
                    style={{ color: this.state.clickedButton === 1 ? '#febf00' : 'white' }}>
                    <ExportFormatBtnIcon fontSizeEnabled={this.props.fontSizeEnabled}>
                      <path d="M452,244h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331,24c-2.2-2.4-5.4-3.8-8.6-3.8H104.6c-22.1,0-40,17.9-40,40v184  H60c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40h4.6v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.2,244,452.1,244,452,244L452,244z M334.3,61l72,72h-72V61z M88.6,60  c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1V244H88.6V60z M423.4,452c0,8.8-7.2,16-16,16H104.6c-8.8,0-16-7.2-16-16  v-24h334.9v24H423.4z M169.9,397h-45.4l-23.3-45.8l-14,17.8v27.9H48V275.7h39.1v50l37.3-50h37.3l-34.1,44.4L169.9,397z M335.8,275.8  V397h-38.6v-86.6l-25,86.6h-26.3l-25.9-86.6V397h-31.1V275.8h54.2l19.6,64.4l18.7-64.4H335.8z M462,367.2V397h-94.8V275.8h41.5v91.4  H462z" />
                    </ExportFormatBtnIcon>
                    <ExportTitle title={getTranslatedKey('KMLText')} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('KMLText')}
                    </ExportTitle>
                  </ExportButton>
                </ExportButtonWrapper>
                <ExportButtonWrapper title={getTranslatedKey('SHPText')}>
                  <ExportButton
                    title={getTranslatedKey('SHPText')}
                    onClick={() => this.onExportClick('SHAPE-ZIP')}
                    style={{ color: this.state.clickedButton === 3 ? '#febf00' : 'white' }}>
                    <ExportFormatBtnIcon fontSizeEnabled={this.props.fontSizeEnabled}>
                      <path d="M452.4,244.6h-4.6v-98.9c0-3.3-1.3-6.4-3.8-8.6L331.4,24.6c-2.2-2.4-5.4-3.8-8.6-3.8H105c-22.1,0-40,17.9-40,40  v184h-4.6c-22.1,0-40,17.9-40,40v104c0,22.1,17.9,40,40,40H65v24c0,22.1,17.9,40,40,40h302.9c22.1,0,40-17.9,40-40v-24h4.6  c22.1,0,40-17.9,40-40v-104c0.1-22.1-17.7-40.1-39.8-40.2C452.6,244.6,452.5,244.6,452.4,244.6L452.4,244.6z M334.7,61.6l72,72h-72  V61.6z M89,60.6c0-8.8,7.2-16,16-16h205.8v101.1c0,6.6,5.4,12,12,12h101.1v86.9H89V60.6z M423.8,452.6c0,8.8-7.2,16-16,16H105  c-8.8,0-16-7.2-16-16v-24h334.9v24H423.8z M60,361.4l37-5.9c3.2,9.4,11.1,14,24,14c10,0,15-2.4,15-7.2c0-2.5-1.1-4.4-3.4-5.8  c-2.3-1.4-6.4-2.7-12.4-3.7c-22.8-3.9-37.4-9-43.9-15.3c-6.4-6.3-9.7-13.8-9.7-22.2c0-11,4.7-20.1,13.9-27.3  c9.2-7.3,22.6-10.9,40.1-10.9c26.4,0,43.9,9.5,52.3,28.6l-33,9c-3.4-7.8-10.4-11.6-20.9-11.6c-8.7,0-13,2.4-13,7.2  c0,2.1,1,3.8,2.9,5.1c2,1.1,5.8,2.3,11.4,3.4c15.5,2.9,26.5,5.6,33.1,7.8c6.6,2.3,12,6.2,16.3,11.6c4.3,5.4,6.6,12,6.6,19.3  c0,11.8-5.3,21.2-15.9,28.6c-10.6,7.3-24.7,11-42,11C86.9,396.8,67.3,385,60,361.4z M310.5,278.7V395h-39.8v-45.3h-30.5V395h-39.8  V278.7h39.8v42.7h30.5v-42.7H310.5z M382.2,352.8V395h-40.5V278.7h55.4c13.8,0,24.3,1.4,31.5,4.3c7.2,2.8,12.9,7.2,17.1,13  c4.2,5.8,6.3,12.4,6.3,19.7c0,11.1-4.3,20-12.9,26.8c-8.6,6.8-20.1,10.2-34.5,10.2H382.2z M381.6,327.7h13.3  c11.8,0,17.6-3.9,17.6-11.6c0-7.3-5.4-10.9-16.3-10.9h-14.7v22.5H381.6z" />
                    </ExportFormatBtnIcon>
                    <ExportTitle title={getTranslatedKey('SHPText')} fontSizeEnabled={this.props.fontSizeEnabled}>
                      {getTranslatedKey('SHPText')}
                    </ExportTitle>
                  </ExportButton>
                </ExportButtonWrapper>
              </ExportButtonsWrapper>
            )
          ) : (
            <SpinnerContainer>
              <Oval
                height={window.innerHeight > 400 ? 80 : 40}
                width={window.innerHeight > 400 ? 80 : 40}
                color="#febf00"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#ccc"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            </SpinnerContainer>
          )}
        </ExportPopUp>
      </>
    );
  }
}
